import React, { Component } from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import { LayeredBackgroundImage } from "containers"
import { Section } from "AtomicComponents"
import { Slideshow, WysiwygContent, VideoBackground, Heading } from "components"
import { childParser } from "containers/utilities"

/** Interactive Slideshow Block Component */
class TextMediaSliderContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: props.active ? props.active : 0
    }
  }
  static propTypes = {
    active: PropTypes.number,
    heading: PropTypes.string,
    description: PropTypes.string,
    disclaimer: PropTypes.string,
    backgroundColor: PropTypes.string,
    bulletsBelow: PropTypes.bool,
    displayOnTop: PropTypes.bool,
    padding: PropTypes.bool,
    items: PropTypes.array.isRequired
  }

  static defaultProps = {
    bulletsBelow: false,
    padding: true
  }

  handleChange = (index) => {
    this.setState({ active: index })
  }
  /**
   * @param {String} [disclaimer] - Dislaimer text as xmlString
   * @param {Array|SlideshowItem} components - Array of components.
   * @param {Boolean} [bulletsBelow] - Display a bullet list below slide.
   * @param {Boolean} [displayOnTop] - display images on top or bottom of content area
   * @returns {ReactElement} React Component
   */
  render() {
    const {
      description,
      disclaimer,
      heading,
      bulletsBelow,
      displayOnTop,
      items,
      padding,
      backgroundColor
    } = this.props
    const activeItem = items.length > 0 && items[this.state.active].props
    const contentSection = activeItem && (
      <div style={[styles.copy, this.state.hidden ? styles.hide : styles.show]}>
        {activeItem.heading && <Heading value={activeItem.heading} tag={"h4"} />}
        {activeItem.blurb && <WysiwygContent xmlString={activeItem.blurb} />}
      </div>
    )
    return (
      <Section
        fullWidth
        backgroundColor={backgroundColor || "#f5f5f5"}
        textAlign={"center"}
        padding={padding}
      >
          {/* padding for column added for SM-1214 */}
          <div style={{
            textAlign:"center",
            width: '100%',
            overflow: 'hidden'
          }}>
            {heading && <Heading tag="h3" value={heading} />}
            {description &&
              <div
                style={styles.description}
                dangerouslySetInnerHTML={{
                  __html: description
                }} />
            }
            {!displayOnTop &&
              <div style={{textAlign:"center"}}>
                {contentSection}
              </div>
            }
            <div style={{ marginBottom: "1em" }}>
              <Slideshow
                noAnimation
                showBullets
                activate={this.state.active}
                handleChange={this.handleChange}
                disclaimer={disclaimer}
                bulletsBelow={bulletsBelow}>
                {items &&
                  items.map((component, index) => {
                    const { video, imageSrc } = component.props
                    return (
                      <div key={index} style={styles.slideshowItem}>
                        {video && <VideoBackground src={video} poster={imageSrc} relative isContainerInView useInView={false} />}
                        {imageSrc &&
                          !video && (
                            <LayeredBackgroundImage backgroundSize="contain" imageSrc={imageSrc} />
                          )}
                      </div>
                    )
                  })}
              </Slideshow>
            </div>
            { displayOnTop &&
              <div style={{textAlign:"center"}}>
                {contentSection}
                {childParser(this.props)}
              </div>
            }
          </div>
      </Section>
    )
  }
}

export default Radium(TextMediaSliderContainer)

const styles = {
  copy: {
    marginTop: "1.5em"
  },
  slideshowItem: {
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    overflow: "hidden" // Fix overflow problem in IE11
  },
  description: {
    fontWeight: "200",
    fontSize: "100%",
    lineHeight: "1.6",
    margin: "1.5em 0",
    letterSpacing: "0.01em"
  }
}



// WEBPACK FOOTER //
// ./src/containers/interactive-slideshow-block/index.jsx